import React from 'react';

import Button from '@common/react/components/Forms/Button';

import { useUserFavoritesProviderContext } from '@app/components/UI/UserFavoritesProvider/UserFavoritesProvider';

interface FavoriteButtonProps {
	url: string;
	title?: string;
	onClick?: () => void;
	style?: any;
}

const FavoritesButton: React.FC<FavoriteButtonProps> = ({
	url, title, style, onClick,
}) => {
	const {
		state: {
			items: userFavorites,
		},
		actions: {
			addFavorite,
			removeFavorite,
		},
	} = useUserFavoritesProviderContext();

	const [isInFavorites, setIsInFavorites] = React.useState<boolean>(false);

	React.useEffect(() => {
		const isInFavorites = userFavorites.map((userFavorite) => userFavorite.url).indexOf(url) > -1;
		setIsInFavorites(isInFavorites);
	}, [userFavorites]);

	const onHandleClick = (e) => {
		e.preventDefault();

		if (!isInFavorites) {
			addFavorite(url, title);
		} else {
			removeFavorite(url);
		}

		onClick && onClick();
	};

	return (
		<Button
			title={isInFavorites ? 'Remove Favorite' : 'Add to Favorites'}
			other={{ style }}
			className={`menu-component__item-favorite-btn ant-btn ${isInFavorites ? 'item-favorite' : ''}`}
			onClick={onHandleClick}
		>
			<i className="fa fa-star" />
		</Button>
	);
};

export default FavoritesButton;
